import { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading';
import { ClockCircleOutlined } from '@ant-design/icons';
import { 
  Form, 
  message, 
  Row, 
  Col,
  DatePicker,
  Table,
  Button,
} from 'antd';
import fetchMiniList from '../../utils/miniFetcher.js';
import axiosInstance from '../../utils/axios.js';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import MovieCard from '../../components/dashboard/MovieCard.jsx';

const { RangePicker } = DatePicker;

const ReservationDetail = () => {
    const navigate = useNavigate();
    const { id, movieId } = useParams();
    const [form] = Form.useForm();
    const [times, setTimes] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [currentMovie, setCurrentMovie] = useState({});
    const [currentShow, setCurrentShow] = useState({});

    useEffect(() => {
        fetchMasters();
    }, []);
 

	useEffect(() => {
		if (currentShow?.dates?.length > 0) {
			const startDate = dayjs(currentShow.dates[0].date);
			const endDate = dayjs(currentShow.dates[currentShow.dates.length - 1].date);

			form.setFieldsValue({
				date: [startDate, endDate]
			});

			// Also build table rows directly from backend dates
			const rows = currentShow.dates.map((d, idx) => ({
                key: d.date,
                serial: idx + 1,
                date_id: d.id,
                date: d.date,
                timeslots: d.timeslots,
            }));
			setTableData(rows);

			// build selectedSlots object from backend status
			const preSelected = {};
			currentShow.dates.forEach(d => {
				preSelected[d.date] = d.timeslots.filter(t => t.status).map(t => t.timeslot);
			});
			// setSelectedSlots(preSelected);
		}
	}, [currentShow, times]);


    const fetchMasters = async () => {
        try {
            const timeResponse = await fetchMiniList("core/timeslot/");
            timeResponse.status ? setTimes(timeResponse.data) : message.error(timeResponse.data);

            const mRes = await fetchMiniList(`movie/movie/${movieId}`);
            mRes.status ? setCurrentMovie(mRes.data) : message.error(mRes.data);

            const sRes = await fetchMiniList(`show-management/shows/${id}`);
            mRes.status ? setCurrentShow(sRes.data) : message.error(sRes.data);

        } catch (error) {
            console.error("Error in fetchMasters:", error);
            message.error("An unexpected error occurred while fetching data");
        }
    };
    
    const gotoReservation = (slot) => {
        navigate("/admin/shows/confirm-reservation", {
            state: {
                selected_slot: slot,
                movie: currentMovie,
                show: currentShow
            }
        });
        
    }

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
            width: "10%",
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            width: "20%",
        },
        {
            title: "Reserve",
            dataIndex: "timeslots",
            key: "timeslots",
            render: (timeslots, record) => (
                <div style={{ display: 'grid', gap: 8 }}>
                {timeslots
                    .filter(t => t.status === true)
                    .map(t => (
                    <Button key={t.id} style={{
                            width: 'fit-content',
                            padding: '2px 8px'
                        }}
                        onClick={() => gotoReservation({ date: record.date, timeslot: t, date_id: record.date_id })}
                    >
                        {`${t.timeslot_title} (${t.timeslot_start} - ${t.timeslot_end})`}
                    </Button>
                    ))}
                </div>
            )
        }
    ];

    return (
        <div className="dashboard">
        <PageHeading name="Select Show for pre reservation" icon={<ClockCircleOutlined />} />
        <br/>
            <MovieCard currentMovie={currentMovie} currentShow={currentShow}/>
            <Form form={form} name="show-form" layout="vertical">
                <Row gutter={[16, 16]}>
                <Col  xs={24} sm={24} md={12} lg={6}>
                    <Form.Item
                        name="date"
                        label="Dates"
                    >
                    <RangePicker disabled/>
                    </Form.Item>
                </Col>
                </Row>
                {tableData.length > 0 && (
                <Table 
                    columns={columns} 
                    dataSource={tableData} 
                    pagination={false} 
                    bordered
                    style={{ marginTop: 20 }}
                    scroll={{ x: 'max-content' }}
                />
                )}
            </Form>
        </div>
    );
};

export default ReservationDetail;
